export default __webpack_public_path__ + "static/211-96bb6505c3f2249b43d7011b234c3dec.gif";